import React from 'react';
import Cancelled from '../../components/AdminNext/Cancelled';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Cancelled — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <Cancelled />
      </HeadLessLayout>
    )
  };
}

export default action;
